import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { userState } from "@/global/store/data/user";

import transactionHistory from "./data/transactionHistory";
import { cardState } from "./data/purchaseSeats/card";
import { cartManagerState } from "./data/purchaseSeats/cartManager";
import { checkoutState } from "./data/purchaseSeats/checkout";
import { creditReportState } from "./data/creditReport";
import { creditState } from "./data/purchaseSeats/credit";
import { eventsState } from "./data/purchaseSeats/events";
import { gameFiltersState } from "./data/gameFilters";
import { inventoriesState } from "./data/purchaseSeats/inventories";
import { purchaseCreditState } from "./data/purchaseCredit";
import { seatMapState } from "./data/seatMap";
import { purchaseAddCredits } from "./data/addCredits/purchaseAddCredits";
import { purchaseGiftCards } from "./data/giftCards/purchaseGiftCards";
import { packagesState } from "./data/purchaseSeats/packages";
import { uiHelpersState } from "./data/uiHelpers";
import { serviceFeeState } from "./data/purchaseSeats/serviceFee";
import { bucketsState } from "./data/purchaseSeats/buckets";
import { paymentPlansState } from "./data/purchaseSeats/paymentPlans";
import { packsState } from "./data/purchaseSeats/packs";
import { recipientUserState } from "./data/purchaseSeats/recipientUser";
import { isAuthenticatingState } from "./data/isAuthenticating";

const reducer = combineReducers({
  data: combineReducers({
    addCredits: combineReducers({
      purchaseAddCredits: purchaseAddCredits.reducer,
    }),
    uiHelpers: uiHelpersState.reducer,
    gameFilters: gameFiltersState.reducer,
    purchaseCredit: purchaseCreditState.reducer,
    purchaseSeats: combineReducers({
      checkout: checkoutState.reducer,
      events: eventsState.reducer,
      inventories: inventoriesState.reducer,
      cartManager: cartManagerState.reducer,
      card: cardState.reducer,
      credit: creditState.reducer,
      serviceFee: serviceFeeState.reducer,
      packages: packagesState.reducer,
      buckets: bucketsState.reducer,
      paymentPlans: paymentPlansState.reducer,
      packs: packsState.reducer,
      recipientUser: recipientUserState.reducer,
    }),
    giftCards: combineReducers({
      purchaseGiftCards: purchaseGiftCards.reducer,
    }),
    creditReport: creditReportState.reducer,
    transactionHistory: transactionHistory,
    seatMap: seatMapState.reducer,
  }),
  user: userState.reducer,
  isAuthenticating: isAuthenticatingState.reducer,
});

const store = configureStore({
  reducer,
});

export default store;

/** exporting type for Global State and App Dispatch */
export type GlobalState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

/** Exporting typed version of selector and dispatch hook for app usage */
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppStore: TypedUseSelectorHook<GlobalState> = useSelector;
